export default __webpack_public_path__ + "static/media/quotes.f73b94a5.svg";